// extracted by mini-css-extract-plugin
export default {"backdrop":"DeactivateModal_backdrop__rEKRW","card":"DeactivateModal_card__Ok6Z4","fadeInScale":"DeactivateModal_fadeInScale__z0Fov","actions":"DeactivateModal_actions__GUELJ"};